/*
 * @Author: Gang Jiang
 * @Date: 2026-05-25 11:08:09
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2026-06-02 21:15:00
 */
import { Table } from 'ant-design-vue'

/** 主表列宽使用百分比，避免 colgroup 生成 px 宽度 */
export const INFLUENCER_TABLE_COLUMNS = [
  { title: 'Date', dataIndex: 'date', key: 'date', width: '9%' },
  {
    title: 'Influencer Username',
    dataIndex: 'influencerUsername',
    key: 'influencerUsername',
    width: '20%',
    ellipsis: true,
  },
  { title: 'Influencer ID', dataIndex: 'influencerId', key: 'influencerId', width: '9%' },
  {
    title: 'Gross Sales',
    dataIndex: 'grossSales',
    key: 'grossSales',
    width: '12%',
    align: 'right',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissions',
    key: 'commissions',
    width: '12%',
    align: 'right',
  },
  { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: '9%', align: 'right' },
  {
    title: 'CR (Units/Clicks)',
    dataIndex: 'cr',
    key: 'cr',
    width: '15%',
    align: 'right',
    className: 'report-col-cr',
  },
  /** 展开列与 Advertisers 表头合并，避免 expandIconColumnIndex 错位 */
  Table.EXPAND_COLUMN,
]

export const ADVERTISER_TABLE_COLUMNS = [
  { title: 'Date', dataIndex: 'date', key: 'date', width: '9%' },
  {
    title: 'Advertiser',
    dataIndex: 'advertiserName',
    key: 'advertiserName',
    width: '20%',
    align: 'left',
    ellipsis: true,
  },
  {
    title: 'Advertiser ID',
    dataIndex: 'advertiserId',
    key: 'advertiserId',
    align: 'right',
    width: '11%',
  },
  {
    title: 'Gross Sales',
    dataIndex: 'grossSales',
    key: 'grossSales',
    width: '12%',
    align: 'right',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissions',
    key: 'commissions',
    width: '12%',
    align: 'right',
  },
  { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: '9%', align: 'right' },
  {
    title: 'CR (Units/Clicks)',
    dataIndex: 'cr',
    key: 'cr',
    width: '13%',
    align: 'right',
    className: 'report-col-cr',
  },
  Table.EXPAND_COLUMN,
]

/** Influencer 报表展开：按 Advertiser 明细（列宽对齐主表 Gross / Commissions / Clicks） */
export const INFLUENCER_BREAKDOWN_COLUMNS = [
  {
    title: 'Advertiser',
    dataIndex: 'advertiserName',
    key: 'advertiserName',
    width: '38%',
    align: 'left',
    ellipsis: true,
  },
  {
    title: 'Gross Sales',
    dataIndex: 'grossSales',
    key: 'grossSales',
    align: 'right',
    width: '22%',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissions',
    key: 'commissions',
    align: 'right',
    width: '22%',
  },
  {
    title: 'Clicks',
    dataIndex: 'clicks',
    key: 'clicks',
    align: 'right',
    width: '18%',
  },
]

/** Advertiser 报表展开：按 Influencer 明细 */
export const ADVERTISER_BREAKDOWN_COLUMNS = [
  {
    title: 'Influencer Username',
    dataIndex: 'influencerUsername',
    key: 'influencerUsername',
    width: '40%',
    align: 'left',
    ellipsis: true,
  },
  {
    title: 'Gross Sales',
    dataIndex: 'grossSales',
    key: 'grossSales',
    align: 'right',
    width: '22%',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissions',
    key: 'commissions',
    align: 'right',
    width: '22%',
  },
  {
    title: 'Clicks',
    dataIndex: 'clicks',
    key: 'clicks',
    align: 'right',
    width: '16%',
  },
]

/** @deprecated 使用 INFLUENCER_BREAKDOWN_COLUMNS */
export const BREAKDOWN_TABLE_COLUMNS = INFLUENCER_BREAKDOWN_COLUMNS

/** 主表展开列宽度（百分比，与上方数据列合计 100%） */
export const REPORT_EXPAND_COLUMN_WIDTH = '14%'
